import { render, staticRenderFns } from "./BotSettings.vue?vue&type=template&id=0042c8fd&scoped=true"
import script from "./BotSettings.vue?vue&type=script&lang=ts"
export * from "./BotSettings.vue?vue&type=script&lang=ts"
import style0 from "./BotSettings.vue?vue&type=style&index=0&id=0042c8fd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042c8fd",
  null
  
)

export default component.exports